/**
 * Copyright © 2026 Adnuntius AS.
 */
import {Component, Input, OnChanges} from '@angular/core';

@Component({
  standalone: false,
  selector: 'adn-targeting-viewability-summary',
  template: '<span>{{data}}%</span>'
})
export class ViewabilitySummaryComponent implements OnChanges {
  @Input() targets: any;

  data: any;

  ngOnChanges(): void {
    const target = this.targets || {};
    this.data = target.viewability;
  }
}
